import React from "react";

import CreateContactForm from "../containers/CreateContactForm";


  const Contact = props => (

  <div className="contact flex" style={{ marginTop: "56px" }}>
    <section
      className="w-50 br flex items-center"
      style={{ minHeight: "calc(100vh - 56px)" }}
    >
      <div className="contact__form">
        <div className="contact__form-title">{props.t("contactTitle")}</div>
        <div>
          <CreateContactForm t={props.t}/>
        </div>
      </div>
    </section>

    <section className="w-50" style={{ height: "calc(100vh - 56px)" }}>
      <div className="contact__map">
        <iframe
          frameBorder="0"
          title="OBER SA"
          src={"https://www.google.com/maps/embed/v1/place?q=place_id:ChIJpXXk57l660cRLRId-t72WvM&key=AIzaSyD2NzcMzgyl7tWaGSwfmrUce5S3GoIOVGE&language="+props.t("mapLanguage")}
          style={{
            overflow: "hidden",
            height: "100%",
            width: "100%",
            position: "absolute",
            top: "0px",
            left: "0px",
            right: "0px",
            bottom: "0px"
          }}
        />
      </div>
      <div className="contact__infos">
        <ul className="contact__infos-list">
          <li className="font-bold">{props.t("contact:headOffice")}</li>
          <li className="font-bold">OBER SA</li>
          <li>Longeville en Barrois</li>
          <li>55014 BAR LE DUC CEDEX</li>
          <li>Tél. : +33 (0)3 29 76 77 78</li>
          <li>Fax. : +33 (0)3 29 45 37 37</li>
          <li>
            <a
              className="font-light black"
              href="mailto:obersound@ober-surfaces.com"
            >
              obersound@ober-surfaces.com
            </a>
          </li>
        </ul>
      </div>
    </section>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js